import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'es',
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: `${window.location.origin}/locales/{{lng}}/{{ns}}.json`
    }
  });

export default i18n;